import creditCardType from 'credit-card-type';
export const cardMonths = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
export const cardYears = () => {
  const year = new Date().getFullYear();
  return Array.from(new Array(15), (v, idx) => ({
    label: year + idx, // ex: 2023
    value: String((year + idx) % 100), // ex: 23 - get last 2 digits and convert to string
  }));
};
export const accountTypes = [
  { label: 'Consumer Checking', value: 'C' },
  { label: 'Consumer Savings', value: 'S' },
  { label: 'Commercial Checking', value: 'X' },
];
// Get Card Brand
export const getCardBrand = (cardNum: string) => {
  const cardBrandDetails = creditCardType(cardNum);
  const cardBrandType = cardBrandDetails && cardBrandDetails[0] && cardBrandDetails[0].niceType;
  let cardBrandCode = '';
  switch (cardBrandType) {
    case 'Visa':
      cardBrandCode = 'VI';
      break;
    case 'Mastercard':
      cardBrandCode = 'MC';
      break;
    case 'American Express':
      cardBrandCode = 'AX';
      break;
    case 'ACH':
      cardBrandCode = 'AC';
      break;
    case 'Diners Club':
      cardBrandCode = 'DC';
      break;
    case 'Discover':
      cardBrandCode = 'DI';
      break;
    case 'Debit':
      cardBrandCode = 'DP';
      break;
    default:
      cardBrandCode = 'VI';
      break;
  }
  return cardBrandCode;
};
